<template>
  <div class="wrap">
    <div class="main">
      <div class="head">
        <div class="left">
          <span style="margin-right: 10px">{{ coinName }}/USDT</span>
          <span style="position: relative" >
            <span @click="selectShow = true">{{ lang.option }} <i class="el-icon-arrow-down"></i></span>
            <div :class="[ selectShow ? 'select':'none']">
              <div class="option" v-for="item in coinList" @click="select(item)">{{item.name}}/USDT</div>
            </div>
          </span>
        </div>
        <div class="right" >
          <i class="el-icon-headset" style="font-size: 20px;font-weight: 600" @click="online"></i>
        </div>
      </div>
      <div class="downInfo">
        <div class="left">
          <el-select v-model="lockFor" placeholder="select">
            <el-option :key="item" :label="item +'s'" :value="item" v-for="item in lockForList"></el-option>
          </el-select>
          <div class="input">
            <el-input v-model="income" disabled></el-input>
          </div>
          <div class="kjxz">
            <div>
              <el-input v-model="amount">
                <i slot="suffix" class="el-input__icon el-icon-money" style="font-size: 20px"></i>
              </el-input>
            </div>
            <div class="items">
              <div :class="['item',item == amount ? 'active':'']" v-for="item in quickAmtList" @click="amount=item">{{item}}U</div>
            </div>
          </div>
          <div class="coin">
            <span>{{lang.coin}} {{coinInfo.coin}} USDT</span>
          </div>
          <div class="buttons">
            <el-button type="success" style="width: 100%;margin-bottom: 10px" @click="buy(1)">{{lang.buyup}}</el-button>
            <el-button type="danger" style="width: 100%;margin-bottom: 10px" @click="buy(0)">{{lang.buyshort}}</el-button>
          </div>
        </div>
        <div class="right">
          <div class="item">
            <span>{{lang.price}} USDT</span>
            <span>{{lang.number}} {{ coinName }}</span>
          </div>
          <div class="item" v-for="item in historyAmt">
            <span v-if="item.price > targetPrice" style="color: red">{{item.price}}</span>
            <span v-else-if="item.price < targetPrice" style="color: green">{{item.price}}</span>
            <span v-else style="font-size: 16px">{{item.price}}</span>
            <span>{{item.qty}}</span>
          </div>
        </div>
      </div>
      <div class="tag">{{lang.order}}</div>
        <div class="orders" >
          <div class="order" v-for="item in orderList">
            <div class="title">
              <div style="font-size: 16px;font-weight: 600;flex: 0 0 40%">
                <span style="color: #0ab57b" v-if="item.selected == 1">buy </span>
                <span style="color: red" v-else-if="item.selected == 0">sell </span>
                <span>{{ item.coinName }}/USDT</span>
              </div>
              <div style="flex: 0 0 60%;text-align: right;color: #5a5a5a">{{lang.orderTime}}:{{ item.ctime }}</div>
            </div>
            <div class="turboos">Turboos</div>
            <div class="line">
              <div >{{lang.Quantity}}(USDT)</div>
              <div >{{lang.Income}}(USDT)</div>
              <div>{{ lang.TradingHours }}(S)</div>
            </div>
            <div class="amt">
              <div>{{ item.amt }}</div>
              <div>{{ item.bonus }}</div>
              <div>{{ item.seconds }}</div>
            </div>
          </div>
          <div class="page">
            <el-button icon="el-icon-caret-left" circle @click="pageClick(0)"></el-button>
            <div class="pageNum">{{page}}</div>
            <el-button icon="el-icon-caret-right" circle @click="pageClick(1)"></el-button>
          </div>
        </div>
    </div>
    <div class="zhezhao" v-if="selectShow" @click="selectShow = false"></div>
    <Bottom />
  </div>
</template>
<script>
  import {
    mapState
  } from 'vuex';
  import { CONF } from '@/assets/js/config'
  import {xhrPost} from "../api/api";
  export default {
    data() {
      return {
        targetPrice : "",
        historyAmt :[],
        coinList :[],
        lockForList :[],
        quickAmtList :[],
        orderList :[],
        coinInfo :{},
        configData :{},
        timer:null,
        selectShow:false,
        noMore:false,
        loading:false,
        coinName:"",
        lockFor:"",
        amount:"",
        income : "income 20%",
        page :1,
        totalNum :0,
      }
    },
    mounted() {},
    activated(){
      this.coinName = this.$route.query.coinName
      this.configData = this.$store.state.configData
      this.getCoinList()
      this.getOrders()
      clearInterval(this.timer)
      this.timer = setInterval(()=>{
        this.getHistoryAmt()
      },3e3)
    },
    beforeDestroy(){
      clearInterval(this.timer);
      this.timer = null;
    },
    computed: {
      ...mapState(['lang','userInfo']),
    },
    methods: {
      online() {
        // let url = this.kefu;
        // if (window.plus) {
        //   let app = plus.os.name == "iOS" ? '' : 'com.android.browser'
        //   plus.runtime.openURL(url, () => {
        //     plus.runtime.openURL(url)
        //   }, app)
        // } else {
        //   window.open(url);
        // }
        window.open(this.configData.cs_url);
      },
      pageClick(bools){
        if (bools == 1){
          var allPage = Math.ceil(this.totalNum / 20)
          if(allPage == this.page){return}
          this.page +=1
        }else {
          if(1 == this.page){return}
          this.page -=1
        }
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth' // 可选，平滑滚动效果
        });
        this.getOrders()
      },
      select(item){
        this.selectShow = false
        this.coinName = item.name
        this.getCoinList()
      },
      getHistoryAmt(){
        this.$xhrGet('/product/historyAmt',{"name":this.coinName+"USDT"})
          .then(res => {
            if (res.err == 0) {
              this.historyAmt = res.data;
              this.targetPrice = res.targetPrice;
            }
          })
          .catch(err => {
            this.$messagebox({
              title: this.lang.tip,
              message: this.lang.conneterr,
              confirmButtonText: this.lang.confirm
            });
          })
      },
      getCoinInfo(){
        this.$xhrGet( '/product/coinInfo')
          .then(res => {
            if (res.err == 0) {
              this.coinInfo = res.data;
              this.lockForList = this.coinInfo.lockFor.split(",")
              this.quickAmtList = this.coinInfo.quickAmt.split(",")
              this.amount = this.quickAmtList[0]
              this.lockFor = this.lockForList[0]
              this.income = "income " + this.coinInfo.income +"%"
            }
          })
      },
      getOrders(){
        this.$xhrGet( '/product/order',{'page':this.page})
          .then(res => {
            if (res.err == 0) {
              // this.orderList = this.orderList.concat(res.data)
              this.orderList = res.data
              this.totalNum = res.totalNum
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth' // 可选，平滑滚动效果
              });
            }
          })
      },
      getCoinList(){
        this.$xhrGet( '/product/coin')
          .then(res => {
            if (res.err == 0) {
              this.coinList = res.data.data;
              if (!this.coinName){
                this.coinName = this.coinList[0].name
              }
              this.getHistoryAmt()
              this.getCoinInfo()
            }
          })
      },
      buy(updown){
        this.$xhrPost( '/product/buy',{
          updown:updown,
          amt:this.amount,
          lockFor:this.lockFor,
          coinName:this.coinName,
        }).then(res => {
          if (res.err == 0) {
            this.$message({message: "",  type: 'success'});
            this.getOrders()
          }else{
            this.$message({message: res.msg,  type: 'error'});
          }
        })
      }
    }
  }
</script>
<style scoped >
.main{
}
.head{
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  margin: 10px;
}
.downInfo{
  display: flex;
  margin: 20px 10px 0 10px;
  justify-content: space-between;
}
.downInfo .left{
  flex: 0 0 45%;
}
.downInfo .left .input{
  margin-top: 10px;
}
.downInfo .left .kjxz{
  margin-top: 10px;
}
.downInfo .left .items{
  display: flex;
  border: 1px solid #dddfe7;
  border-top: none;
  margin-top: -1px;
}
.downInfo .left .items .item{
  font-size: 12px;
  padding: 5px;
  border-right: 1px solid #dddfe7;
}
.downInfo .left .coin{
  margin: 5px;
  font-size: 10px;
}
.downInfo .left .buttons{
  margin: 10px 0;
}
.downInfo .left .items .active{
  background: #b2decf;
}

.downInfo .right{
  flex: 0 0 45%;
}
.downInfo .right .item{
  display: flex;
  font-size: 12px;
  margin: 5px;
  justify-content: space-between;
}
.tag {
  padding: 10px 5px;
  background: #5c62b3;
  color: #fff;
}
.orders{
  margin-bottom: 50px;
}
.orders .order{
  padding: 10px 10px;
  border-bottom: 3px solid #e2dede;
}
.orders .order .title{
  display: flex;
  align-items: center;
  font-size: 12px;
}
.orders .order .line{
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #5a5a5a
}
.orders .order .line div{
  flex: 0 0 30%;
  text-align: center;
}
.orders .order .turboos{
  text-align: right;
  font-size: 16px;
  font-weight: 600;
  color: #9e9595;
  margin: 10px 0;
}
.orders .order .amt{
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  margin-top: 5px;
  padding-bottom: 20px;
}
.orders .order .amt div{
  flex: 0 0 30%;
  text-align: center;
}




.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered {
  margin-left: 0;
}
.zhezhao{
  position: fixed;
  background: #000;
  bottom: 0;
  z-index: 10;
  right: 0;
  left: 0;
  top: 0;
  opacity: 0.6;
}
.select{
  width: 140px;
  position: fixed;
  top: 40px;
  //left: -70px;
  background: #fff;
  z-index: 20;
  padding: 10px;
  font-size: 13px;
  height: 300px;
  overflow: auto;
  text-align: center;
  box-shadow: 2px 2px 5px #0000006a;
  transition: all .5s ease;
}
.none{
  height: 0;
  overflow: auto;
}
.select .option{
  padding: 5px;
}
.select .option:hover{
  color: red;
}
.page{
  margin-top: 20px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
}
.page .pageNum{
  margin: 20px;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  font-weight: 600;
}
</style>